.a6{overflow:hidden;}